'use client';

import './QuizForm.css';
import { IInputField, QuizFormProps } from '../types';
import { handleContactChange } from '../utils/utils';
import { InputTextField } from '@/widgets/OrderForm/ui/InputTextField/InputTextField';
import { TextareaField } from '@/widgets/OrderForm/ui/TextareaField/TextareaField';
import { ConsentCheckbox } from '@/shared/ui/ConsentCheckbox/ConsentCheckbox';
import { useState } from 'react';
import { SimpleModal } from '@/features/Modal/SimpleModal';

const QuizForm: React.FC<QuizFormProps> = ({
  contactPlaceholder,
  contactInfo,
  setContactInfo,
  consentData,
}) => {
  const [simpleModal, setSimpleModal] = useState(false);
  const [activeModalType, setActiveModalType] = useState<'offer' | 'privacy' | 'terms' | null>(
    null
  );

  const handleAgreementClick = (label: 'offer' | 'privacy' | 'terms') => {
    setActiveModalType(label);
    setSimpleModal(true);
  };

  const handleModalState = () => {
    setSimpleModal(false);
    setActiveModalType(null);
  };

  const getModalContentByType = () => {
    switch (activeModalType) {
      case 'offer':
        return consentData.offerAgreement;
      case 'privacy':
        return consentData.privacyPolicy;
      case 'terms':
      default:
        return consentData.termsOfUse;
    }
  };

  const nameField: IInputField = {
    label: contactPlaceholder.name,
    autoComplete: 'name',
    pattern: /^[\p{L}\s\p{M}\-'"]{0,50}$/u,
    cssName: 'name',
    minLength: 1,
    maxLength: 20,
    required: true,
    onChange: e => handleContactChange(e, setContactInfo),
    setContactInfo: setContactInfo,
  };

  const contactField: IInputField = {
    label: contactPlaceholder.phoneEmailTg,
    autoComplete: 'tel',
    pattern:
      /^(([a-zA-Z0-9_\.+\-]+@[a-zA-Z0-9\-]+\.[a-zA-Z]{2,})|(\+?[\d\- ]{1,3}[\d\s\-]{1,15})|(@[a-zA-Z0-9_]{3,32}))$/,
    cssName: 'contact',
    minLength: 3,
    maxLength: 30,
    required: true,
    onChange: e => handleContactChange(e, setContactInfo),
    setContactInfo: setContactInfo,
  };

  const commentField: IInputField = {
    label: contactPlaceholder.comment,
    autoComplete: 'comment',
    pattern: /^[\p{L}\s\p{M}\-'"]{0,50}$/u,
    cssName: 'comment',
    minLength: 2,
    maxLength: 100,
    required: false,
    onChange: e => handleContactChange(e, setContactInfo),
    setContactInfo: setContactInfo,
  };
  const consentField = {
    texts: consentData.consentCheckboxData,
    onAgreementButtonClick: handleAgreementClick,
  };

  const modalProps = {
    modalState: simpleModal,
    type: activeModalType,
    content: getModalContentByType(),
    handleModalState: () => setSimpleModal(false),
  };

  return (
    <div className="quiz__contact-form">
      <InputTextField fieldData={nameField} />
      <InputTextField fieldData={contactField} />
      <TextareaField fieldData={commentField} />
      <ConsentCheckbox {...consentField} />
      <SimpleModal modalProps={modalProps} handleModalState={handleModalState} />
    </div>
  );
};

export default QuizForm;
